module.exports = __webpack_public_path__ + "static/img/ilovemilk.817b42c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ilovemilk.jpg
// module id = 8IXq
// module chunks = 1